<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.goodstransfer') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item dropdown-filter">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="selected.status == 'all'"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="selected.status == 'padding'"
                    class="badge badge-info">{{ $t('status.gt.padding') }}</span>
                  <span
                    v-if="selected.status == 'done'"
                    class="badge badge-success">{{ $t('status.gt.done') }}</span>
                </template>
                <template v-if="selected.warehouse !== 'all'">
                  <span class="badge badge-secondary">{{ getWarehouseInfo(selected.warehouse).warehouse_name }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="selected.status"
                      class="form-control form-control-sm"
                      @change="handleStatusChange">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        value="padding"
                        class="text-info">{{ $t('status.gt.padding') }}</option>
                      <option
                        value="done"
                        class="text-success">{{ $t('status.gt.done') }}</option>
                    </select>
                  </div>
                  <div class="form-group mb-0">
                    <label>{{ $t('message.store') }}</label>
                    <select
                      v-model="selected.warehouse"
                      class="form-control form-control-sm"
                      @change="handleWarehouseChange">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        v-for="(item, index) in warehouses"
                        :value="item.warehouse_id">
                        {{ item.warehouse_name }}
                      </option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-if="ready"
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 160px;">{{ $t('documents.gt') }}</th>
              <th class="no-sort">{{ $t('message.item') }}</th>
              <th class="no-sort">{{ $t('apps.inventory.message.transferfrom') }}</th>
              <th class="no-sort">{{ $t('apps.inventory.message.transferto') }}</th>
              <th>{{ $t('apps.inventory.message.transferdate') }}</th>
              <th class="no-sort">{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="goodstransfers.length === 0"
                colspan="6"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr v-for="(item, index) in goodstransfers">
              <td :data-order="item.gt_id">
                <router-link-custom
                  :to="{name: 'GoodsTransferEdit', query: {
                    gt_id: item.gt_id,
                    gt_code: item.gt_code
                  }}"
                  :text="item.gt_code"
                  :to_appid="3"
                  :current_appid="3"/>
              </td>
              <td>
                <item-list :orders="item.orders" />
              </td>
              <td>
                <router-link-custom
                  :to="{name: 'WarehouseEdit', query: {
                    id: getWarehouseInfo(item.stockout.warehouse_id).warehouse_id,
                    name: getWarehouseInfo(item.stockout.warehouse_id).warehouse_name,
                  }}"
                  :text="getWarehouseInfo(item.stockout.warehouse_id).warehouse_name"
                  :to_appid="3"
                  :current_appid="3"
                  :disabled="getWarehouseInfo(item.stockout.warehouse_id).is_deleted == true"/>
              </td>
              <td>
                <router-link-custom
                  :to="{name: 'WarehouseEdit', query: {
                    id: getWarehouseInfo(item.stockin.warehouse_id).warehouse_id,
                    name: getWarehouseInfo(item.stockin.warehouse_id).warehouse_name,
                  }}"
                  :text="getWarehouseInfo(item.stockin.warehouse_id).warehouse_name"
                  :to_appid="3"
                  :current_appid="3"
                  :disabled="getWarehouseInfo(item.stockin.warehouse_id).is_deleted == true"/>
              </td>
              <td :data-order="item.scheduled_at">
                <template>
                  <span v-if="item.status == 'padding'">{{ moment(item.scheduled_at).fromNow() }}</span>
                  <span v-else>{{ getDate(item.scheduled_at) }}</span>
                </template>
              </td>
              <td>
                <template>
                  <span
                    v-if="getGoodsTransferStatus(item, $t).status == 'completed'"
                    class="text-success">
                    {{ getGoodsTransferStatus(item, $t).message }}
                  </span>
                  <span
                    v-else-if="getGoodsTransferStatus(item, $t).status == 'uncompleted'"
                    class="text-info">
                    {{ getGoodsTransferStatus(item, $t).message }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'GoodsTransferAll',

  mixins: [userPermissionMixin],

  data () {
    return {
      ready: false,
      dataTable: null,
      selected: {
        status: this.$route.query.status || 'all',
        warehouse: this.$route.query.wh || 'all',
      },
      query: {
        page: this.$route.query.page,
        wh: this.$route.query.wh,
        status: this.$route.query.status,
      },
    }
  },

  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      goodstransfers: 'getGoodstransfers',
      getGoodsTransferStatus: 'getGoodsTransferStatus',
      getWarehouseInfo: 'getWarehouseInfo',
    }),
  },

  watch: {
    ready (newVal) {
      if (newVal === true) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 5,
        submenuAtIdx: 0,
      })
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.selected.status = 'all'
        this.selected.warehouse = 'all'

        this.query.page = undefined
        this.query.wh = undefined
        this.query.status = undefined

        this.fetchData()
      }
    },
  },

  async created () {
    // get warehouses
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }

    // get goodstransfers
    await this.fetchData()

    // set ready
    this.ready = true
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 6,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 5,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, ['clearGoodstransfers'])
  },

  methods: {
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getGoodstransfers', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        wh: this.query.wh,
        status: this.query.status,
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    handleStatusChange () {
      this.query.page = 1
      this.query.status = this.selected.status !== 'all'
        ? this.selected.status
        : null

      this.fetchData()

      // hide dropdown
      if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
        $('button.filter').dropdown('toggle')
      }
    },
    handleWarehouseChange () {
      this.query.page = 1
      this.query.wh = this.selected.warehouse !== 'all'
        ? this.selected.warehouse
        : null

      this.fetchData()

      // hide dropdown
      if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
        $('button.filter').dropdown('toggle')
      }
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
  .dropdown > button {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodstransfer/All.vue